import React, { useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_DOESNT_MEETS_CASE } from '../../../utilities';

const EventNotMeetCase = ({notMeetCaseDef, textAreasNotMeetCase, handleNewTextAreaDelete}) => {
    const myFirstEleRef = useRef(null);
    let blankTextAreas = textAreasNotMeetCase.some(i => i=='')

    const addTextAreaNotmeetCase = () => {
        setTimeout(() => {
            notMeetCaseDef((prevTextAreas) => [...prevTextAreas, ""]);
        }, 400);
      };
      
    const handleTextAreaChangeNotMeetCase = (index, e) => {
        const value = e.target.value;
        const updated = [...textAreasNotMeetCase];
        updated[index] = value;
        notMeetCaseDef(updated);
      };
    return (
      <div className="ct_event_main">
        <div className="card w-100" >
        <div className="card-header event_txtarea_header">
          Event does not meet case definition
        </div>

        <div className="ct_textarea_btn_div">
          <p className="">Additional category for analysis</p>
          <TransitionGroup>
            {textAreasNotMeetCase.map((textAreaValue, index) => (
              <CSSTransition
               nodeRef={myFirstEleRef}
              
                key={index}
                timeout={1000}
                classNames="fade"
              >
              <div>
                  {index !== 0 && <button
                  onClick={() => handleNewTextAreaDelete(textAreasNotMeetCase, index)}
                  className="minus_btn"
              style={{right:"8px"}}

                              >
                  <span>x</span>
                              </button>}
                    <textarea
                    name="notmeetCase"
                      value={textAreaValue}
                      onChange={(event) =>
                        handleTextAreaChangeNotMeetCase(index, event)
                      }
                      placeholder="Type event definition"
                    />
              </div>
              </CSSTransition>
            ))}
          </TransitionGroup>
          <button
          disabled={blankTextAreas}
            onClick={addTextAreaNotmeetCase}
            className="plus_btn"
          >
            <span>+</span>
          </button>
        </div>
      </div>
      </div>
    );
};

export default EventNotMeetCase;

export const EventNotMeetCaseAPIData = ({handleNewTextAreaDelete, notMeetUpdateCaseDef,handleDeleteClick, textAreaAddNotMeetCase, leveldata, getTextAreaChange}) => {
  let blankTextAreas = textAreaAddNotMeetCase.some(i => i=='')
    let leveldataNotmet = leveldata;
    const addTextAreaNotmeetCase = () => {
      setTimeout(() => {
        notMeetUpdateCaseDef((prevTextAreas) => [...prevTextAreas, ""]);
        getTextAreaChange(true)
      }, 400);
    };   
    const [modifiedData, setModifiedData] = useState([])

    
    const handleTextAreaChangeNotMeetCase = (e, key) => {
      if(e.target.value ===''){
        getTextAreaChange(false)
        
       }else{
        getTextAreaChange(true)
   
      }
        const value = e.target.value;
        let matchedId = leveldataNotmet.filter(i =>{
          if(i.event_doesnt_meets_case_id === key){
            i.event_doesnt_meets_case_definition = value
          }
        })
        setModifiedData(matchedId)
      };
      const updatedDataforApi =(e, index)=>{
        const value = e.target.value;
    const updatedValue = [...textAreaAddNotMeetCase];
    updatedValue[index] = value;
    notMeetUpdateCaseDef(updatedValue);
    
      }

    const myNodeRef = useRef(null);
    
    
    return (
        <div className="card w-100" >
        <div className="card-header event_txtarea_header">
          Event does not meet case definition
        </div>

        <div className="ct_textarea_btn_div">
          <p className="">Additional category for analysis</p>
            {leveldataNotmet?.map((textAreaValue, index) => {
                return(
             
              <div key={textAreaValue.event_doesnt_meets_case_id}>
                  {index !==0 && <button
                      onClick={() => handleDeleteClick(EVENT_CLASSIFICATION_LEVEL_BRIGHTON,  textAreaValue.event_doesnt_meets_case_id, EVENT_DOESNT_MEETS_CASE)}
                        className="minus_btn"
                        style={{right:"8px"}}
                         >
                           <span>x</span>
                            </button>}
                    <textarea
                    name="notmeetCase"
                      value={textAreaValue.event_doesnt_meets_case_definition}
                      onChange={(event) =>
                        handleTextAreaChangeNotMeetCase( event, textAreaValue.event_doesnt_meets_case_id)
                      }
                      placeholder="Type event definition"
                    />
              </div>
            )})}
            { textAreaAddNotMeetCase?.map((txtArea, index) =>{
        return(
          <div className="textarea_item " key={index}>
          <button
              onClick={() => handleNewTextAreaDelete(textAreaAddNotMeetCase, index)}
              className="minus_btn"
              style={{right:"8px"}}
            >
              <span>x</span>
            </button>
              <textarea
              value={txtArea}
              name='addtextarea'
              onChange={(event) => updatedDataforApi(event , index)}
              placeholder="Type event definition"
            /> 
            
          </div>
      )
      })}
          <button
          disabled={blankTextAreas || leveldataNotmet[0]?.event_doesnt_meets_case_definition===""}
            onClick={addTextAreaNotmeetCase}
            className="plus_btn"
          >
            <span>+</span>
          </button>
        </div>
      </div>
    );
};